import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import Seo from '../../../../components/Misc/Seo';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/ontario-mine-rescue/OMR_Slider.jpg';
import projectImage2 from '../../../../assets/images/work/ontario-mine-rescue/OMR_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/ontario-mine-rescue/OMR_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/ontario-mine-rescue/OMR_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/ontario-mine-rescue/OMR_Slider_5.jpg';

import Data_OntarioMineRescue from './Data_OntarioMineRescue';

function Work_OntarioMineRescue() {
    const canonical = 'https://studio.norcat.org/OurWork/ontario-mine-rescue';
    const title = 'Ontario Mine Rescue | Studio NORCAT - Driven by experiences that matter.';
    const description = 'Developed by Studio NORCAT, Ontario Mine Rescue is an installation and VR experience that introduces visitors to the world of mine rescue through immersive storytelling, interactive exploration, and public education.';

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${projectImage1}`}
                ogImageAlt="Preview of the Ontario Mine Rescue project"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${projectImage1}`}
                twitterImageAlt="Preview of the Ontario Mine Rescue project"
            />
            <DetailedHeader
                heading="Inside the World of Ontario Mine Rescue"
                client="Dynamic Earth / Ontario Mine Rescue"
                service="Installation / VR"
                date="2020 - Present"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=MS6vbAbuhzk"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Ontario Mine Rescue project screenshot 1',
                    },
                    {
                        image: projectImage2,
                        alt: 'Ontario Mine Rescue project screenshot 2',
                    },
                    {
                        image: projectImage3,
                        alt: 'Ontario Mine Rescue project screenshot 3',
                    },
                    {
                        image: projectImage4,
                        alt: 'Ontario Mine Rescue project screenshot 4',
                    },
                    {
                        image: projectImage5,
                        alt: 'Ontario Mine Rescue project screenshot 5',
                    },
                ]}
            />

            {Data_OntarioMineRescue.content}
        </>
    );
}

export default Work_OntarioMineRescue;
